import { render } from "./ico_icon.vue?vue&type=template&id=62ffd998&scoped=true"
import script from "./ico_icon.vue?vue&type=script&lang=js"
export * from "./ico_icon.vue?vue&type=script&lang=js"

import "./ico_icon.vue?vue&type=style&index=0&id=62ffd998&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ffd998"]])

export default __exports__